export const formatEmiratesId = (value: unknown) => {
  const digits = String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, 15);

  return [digits.slice(0, 3), digits.slice(3, 7), digits.slice(7, 14), digits.slice(14, 15)]
    .filter(Boolean)
    .join("-");
};
